(() => {
  const initHeroOverlay = () => {
    const serverHeader = document.querySelector('[data-topshelf-article-header]');
    const featuredImage = document.querySelector('.blog-post-featured-image');
    const wrapper = featuredImage?.closest('.section-content-wrapper');
    const existingHeader = wrapper?.querySelector(':scope > header');

    if (!featuredImage) {
      const contentWrapper = serverHeader?.closest('.section-content-wrapper');
      if (contentWrapper && contentWrapper.firstElementChild !== serverHeader) contentWrapper.prepend(serverHeader);
      return;
    }

    if (featuredImage.querySelector('.topshelf-blog-featured-hero__content')) return;

    const buildHeaderFromData = () => {
      const data = document.querySelector('[data-topshelf-article-hero-data]');
      const title = data?.dataset.title?.trim();
      const date = data?.dataset.date?.trim();
      const author = data?.dataset.author?.trim();
      const blogTitle = data?.dataset.blogTitle?.trim();
      const blogUrl = data?.dataset.blogUrl?.trim();

      if (!title) return null;

      const header = document.createElement('header');

      if (blogUrl) {
        const breadcrumb = document.createElement('a');
        breadcrumb.className = 'topshelf-blog-hero-breadcrumb';
        breadcrumb.href = blogUrl;
        breadcrumb.textContent = `Back to ${blogTitle || 'Blog'}`;
        header.appendChild(breadcrumb);
      }

      const heading = document.createElement('h1');
      heading.textContent = title;
      header.appendChild(heading);

      if (date || author) {
        const details = document.createElement('div');
        details.className = 'blog-post-details blog-post-info-text';

        if (date) {
          const dateText = document.createElement('span');
          dateText.textContent = date;
          details.appendChild(dateText);
        }

        if (author) {
          const authorText = document.createElement('span');
          authorText.textContent = `By ${author}`;
          details.appendChild(authorText);
        }

        header.appendChild(details);
      }

      return header;
    };

    const buildTagsFromData = () => {
      const data = document.querySelector('[data-topshelf-article-hero-data]');
      const blogUrl = data?.dataset.blogUrl?.trim();
      const tags = data?.dataset.tags?.split('||').map((tag) => tag.trim()).filter(Boolean) || [];

      if (!blogUrl || !tags.length) return null;

      const list = document.createElement('div');
      list.className = 'topshelf-blog-hero-tags';
      list.setAttribute('aria-label', 'Article tags');

      tags.slice(0, 5).forEach((tag) => {
        const link = document.createElement('a');
        const handle = tag
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');

        if (!handle) return;

        link.href = `${blogUrl}/tagged/${handle}`;
        link.textContent = tag;
        list.appendChild(link);
      });

      if (!list.children.length) return null;

      return list;
    };

    const header = serverHeader || buildHeaderFromData() || existingHeader;

    if (!header || featuredImage.contains(header)) return;

    featuredImage.classList.add('topshelf-blog-featured-hero');
    header.classList.add('topshelf-blog-featured-hero__content');
    featuredImage.appendChild(header);

    const tags = buildTagsFromData();
    if (tags) featuredImage.appendChild(tags);
  };

  const init = () => {
    initHeroOverlay();

    const articleContent =
      document.querySelector('.blog-post-content rte-formatter') ||
      document.querySelector('article .rte') ||
      document.querySelector('.blog-post-content') ||
      document.querySelector('article');

    if (!articleContent) return;

    const headings = Array.from(articleContent.querySelectorAll('h1, h2, h3, h4, h5, h6'))
      .filter((heading) => heading.textContent.trim());

    const existingToc = document.querySelector('[data-topshelf-article-toc], #article-toc');
    const toc = existingToc || document.createElement('nav');
    toc.id = toc.id || 'article-toc';
    toc.classList.add('article-toc');
    toc.setAttribute('data-topshelf-article-toc', '');
    toc.setAttribute('aria-label', 'Article navigation');

    if (!headings.length) {
      toc.hidden = true;
      return;
    }

    if (!existingToc) {
      const shell = document.createElement('aside');
      shell.className = 'topshelf-article-toc-shell';
      shell.appendChild(toc);

      const layout = document.createElement('div');
      layout.className = 'topshelf-article-toc-layout';

      const main = document.createElement('div');
      main.className = 'topshelf-article-toc-main';

      articleContent.parentNode.insertBefore(layout, articleContent);
      layout.appendChild(shell);
      layout.appendChild(main);
      main.appendChild(articleContent);
    } else {
      const shell = toc.closest('.topshelf-article-toc-shell') || toc.parentElement;
      shell?.classList.add('topshelf-article-toc-shell');
    }

    const slugCounts = new Map();
    const getSlug = (text) => {
      const base = text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || 'section';
      const count = slugCounts.get(base) || 0;
      slugCounts.set(base, count + 1);
      return count ? `${base}-${count + 1}` : base;
    };

    const links = headings.map((heading) => {
      if (!heading.id) {
        let slug = getSlug(heading.textContent.trim());
        while (document.getElementById(slug)) {
          slug = `${slug}-${Math.floor(Math.random() * 1000)}`;
        }
        heading.id = slug;
      }

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.className = `article-toc__link article-toc__link--${heading.tagName.toLowerCase()}`;
      return {heading, link};
    });

    toc.replaceChildren();

    const title = document.createElement('p');
    title.className = 'article-toc__title';
    title.textContent = 'In this article';
    toc.appendChild(title);

    const list = document.createElement('div');
    list.className = 'article-toc__links';
    links.forEach(({link}) => list.appendChild(link));
    toc.appendChild(list);

    // Horizon scrolls .page-wrapper instead of the document at 990px and up.
    const getScrollContainer = () => {
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper && getComputedStyle(wrapper).overflowY === 'auto') return wrapper;
      return document.scrollingElement || document.documentElement;
    };

    const getScrollOffset = () => {
      const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0;
      return headerHeight + 24;
    };

    toc.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;

      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;

      event.preventDefault();
      const container = getScrollContainer();
      const top = target.getBoundingClientRect().top + container.scrollTop - getScrollOffset();
      window.history.replaceState(null, '', link.hash);
      container.scrollTo({top, behavior: 'smooth'});
    });

    const setActive = (activeHeading) => {
      links.forEach(({heading, link}) => {
        link.classList.toggle('is-active', heading === activeHeading);
      });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

          if (visible[0]) setActive(visible[0].target);
        },
        {
          rootMargin: `-${getScrollOffset()}px 0px -68% 0px`,
          threshold: 0.01,
        },
      );

      links.forEach(({heading}) => observer.observe(heading));
    }

    setActive(links[0]?.heading);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else {
    init();
  }
})();
